<template>
    <div v-if="websites.length > 0">
        <div v-if="data && data.length>0">

            <div class="row d-flex align-center justify-center">
                <div class="col-md-12">
                    <p class="ma-0 mt-5 fw-600 fs-24 mb-5">Active coupons</p>
                </div>
                <div class="col-md-6 w-100 pb-5" v-for="discount in data">
                    <div class="white-container d-flex flex-row justify-space-between pa-8">
                        <div class="d-flex flex-row align-center">
                            <v-img max-height="48px" max-width="48px" contain :src="$root.getSrc('/default/drop_icons/'+getType(discount.type)[0]+'.svg')"></v-img>
                            <div class="ml-10 d-flex flex-column">
                                <p class="ma-0 fw-600 fs-18">
                                    {{getType(discount.type)[1]}}
                                </p>
                                <p class="ma-0 pt-4 fw-400 fs-16" v-if="discount.type == 'free_shipping_to_address'">
                                    {{JSON.parse(discount.description).country}},&nbsp; {{JSON.parse(discount.description).street}},&nbsp; {{JSON.parse(discount.description).postal}},&nbsp; {{JSON.parse(discount.description).city}},&nbsp; {{JSON.parse(discount.description).state}}
                                </p>
                                <p class="ma-0 pt-4 fw-400 fs-16" v-if="discount.type == 'shipping'">
                                    {{discount.discount_number}} AUD
                                </p>
                                <div  v-if="discount.type == 'category'"  class="row">
                                    <div class="col-md-6">
                                        <p class="ma-0 pt-4 fw-400 fs-16">
                                            <span v-if="discount.category_id == 0">All categories</span>
                                            <span v-else-if="discount.category">{{discount.category.name}}</span>
                                            <span v-else>Category deleted</span>
                                        </p>
                                    </div>
                                    <div class="col-md-6">
                                        <p class="ma-0 pt-4 fw-400 fs-16">
                                            <span v-if="discount.discount_number">{{discount.discount_number}}&nbsp;AUD</span>
                                            <span v-else-if="discount.discount_percentage">{{discount.discount_percentage}}%</span>
                                        </p>
                                    </div>
                                </div>
                                <div  v-if="discount.type == 'codes'"  class="row">
                                    <div class="col-md-12">
                                        <p class="ma-0 pt-4 fw-400 fs-16">
                                            <span>Code: {{discount.code}}, {{discount.discount_number ? discount.discount_number +' AUD' : discount.discount_percentage+'%'}}</span>
                                        </p>
                                    </div>
                                </div>
                                <p class="ma-0 pt-4 fw-400 fs-16" v-if="discount.type == 'products'">
                                    <span class="mr-2" v-for="(product,index) in discount.products" v-if="product.product">{{product.product.name}} <span v-if="index+1 != discount.products.length">,</span></span>
                                </p>
                            </div>
                        </div>
                        <div></div>
                        <div class="d-flex align-center">
                            <v-btn v-ripple="false" :to="'/coupons/' + discount.id"  class="ml-2 white--text drop-button button-primary-active" color="#2F80ED">
                                Manage
                            </v-btn>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row d-flex align-center justify-center mt-5">
           <div class="col-md-12 pl-0">
               <p class="ma-0 mt-5 fw-600 fs-24">Add coupon</p>
           </div>
            <div class="col-md-12 white-container d-flex flex-row justify-space-between pa-8 mt-5" v-for="coupon in types">
                <div class="d-flex flex-row align-center">
                    <v-img max-height="48px" max-width="48px" contain :src="$root.getSrc('/default/drop_icons/'+coupon.icon+'.svg')"></v-img>
                    <div class="ml-10 d-flex flex-column">
                        <p class="ma-0 fw-600 fs-18">
                            {{coupon.name}}
                        </p>
                        <p class="ma-0 pt-4 fw-400 fs-14">
                            {{coupon.description}}
                        </p>
                    </div>
                </div>
                <div class="d-flex align-center">
                    <v-btn v-ripple="false" :to="'/coupons/create/' + coupon.type"  class="ml-2 white--text drop-button button-primary-active" color="#2F80ED">
                        Add coupon
                    </v-btn>
                </div>
            </div>
        </div>
    </div>
    <div v-else class="w-100 mt-5">
        <div class="d-flex justify-space-between mb-5">
            <p class="ma-0 fs-36 fw-400">You need to create website first</p>
            <v-btn v-ripple="false"  to="/websites/create"  class="ml-2 white--text drop-button button-primary-active" color="#2F80ED">
                Create new website
            </v-btn>
        </div>

        <v-skeleton-loader
            v-bind="attrs"
            type="image, actions"
        ></v-skeleton-loader>
    </div>

</template>
<style>
.v-expansion-panel-content__wrap {
    padding-left: 0!important;
}
</style>
<script>
import {getBreads, storeBread, editBread, deleteBread} from "../../api/bread";
import {exportToCsv,exportUsageToCsv} from "../../api/promotions";
import EditAddCode from './edit-add';
export default {
    components:{EditAddCode},
    data:() => {
        return{
            attrs: {
                class: 'mb-6',
                boilerplate: true,
                elevation: 2,
            },
            types:[
                {
                    icon: 'code',
                    type: 'codes',
                    name: 'Discount with code',
                    description: 'Create discount code'
                },
                {
                    icon: 'shirt',
                    type: 'products',
                    name: 'Discount per products',
                    description: 'Add discount to chosen products from your store'
                },
                {
                    icon: 'category_shirt',
                    type: 'category',
                    name: 'Discount per product category',
                    description: 'Add discount to chosen products category'
                },
                // {
                //     icon: 'users_icon',
                //     type: 'user_discount',
                //     name: 'Discount per user',
                //     description: 'Add discount for chosen users'
                // },
                {
                    icon: 'free_ship',
                    type: 'shipping',
                    name: 'Free shipping from',
                    description: 'Create discount for shipping from chosen cart value'
                },
                {
                    icon: 'pickup',
                    type: 'free_shipping_to_address',
                    name: 'Free pickup from the point',
                    description: 'Add free pickup from chosen point'
                },
            ],
            code:null,
            data:[],
            codes_with_parent:[],
            duration: 300,
            offset: 0,
            easing: 'easeInOutCubic',
            selectedDiscounts: [],
            importedDiscounts: []
        }
    },
    computed:{
        website(){
            return this.$store.getters.activeWebsite;
        },
        websites(){
            return this.$store.getters.websites;
        }
    },
    mounted(){
        this.getData();
    },
    methods:{
        getType(type){
          let discount = [];
          this.types.forEach(discountType => {
              if(discountType.type == type) {
                  discount.push(discountType.icon);
                  discount.push(discountType.name);
              }
          })
          return discount;
        },
        deletePromotion(item){
            this.$confirm(this.$t('Promotion deleting'), this.$t('Are you sure, you want delete this promotion?'), {accept: {text: 'Yes', color:'red'}, cancel: {text: 'No'}}).then(res => {
                deleteBread('Promotion', item.id, {model_name:'Shop/Promotion'}).then(response => {
                    this.getData();
                    this.$store.commit('app/ADD_MESSAGE', {text: this.$t('Succesfully deleted'), type: 'success'});
                })
            })
        },
        editPromotion(item){
            if(item.discount_percentage){
                item.discount_type = 'percentage';
            }else{
                item.discount_type = 'number';
            }
            this.$set(this, 'edit', item);
        },
        getData(){
            getBreads('Promotion', {model_name:'Shop/Promotion', relations:['category', 'products','discountUsage'], per_page:1000000, website_id: this.website.id, dont_calculate_price: true}).then(response => {
                this.codes_with_parent = response.data.filter(discount=>discount.parent_discount_id);
                this.data = response.data.filter(discount=>!discount.parent_discount_id && discount.archived === 0 && discount.type !=='import_csv');
                let parents = response.data.filter(discount=> discount.type === 'import_csv');
                this.importedDiscounts = [];
                parents.forEach(potentialParent=>{
                    let obj = {
                        parent: potentialParent,
                        children: []
                    }
                    this.codes_with_parent.forEach(code=>{
                        if(code.parent_discount_id === potentialParent.id){
                            obj.children.push(code);
                        }
                    })
                    if(obj.children.length>0){
                        this.importedDiscounts.push(obj)
                    }
                });
            })
        },
        addDiscount(type){
            this.edit = {
                discount_type: 'number',
                type: type,
                products:[]
            }
        },

        saveShipping(){
            if(this.$refs.shipping_form.my_validate()){
                var data = this.data.find(x => x.type == 'shipping');
                if(data.id){
                    var func = editBread('Promotion', {model_name:'Shop/Promotion', ...data}, data.id);
                }else{
                    var func = storeBread('Promotion', {model_name:'Shop/Promotion', ...data});
                }
                func.then(response => {
                    this.getData();
                    this.edit = null;
                    this.$store.commit('app/ADD_MESSAGE', {text: 'Succesfully', type: 'success'});
                })
            }
        },
        deleteShipping(){
            this.$confirm(this.$t('Free shipping deleting'), this.$t('Are you sure, you want delete this promotion?'), {accept: {text: 'Yes', color:'red'}, cancel: {text: 'No'}}).then(res => {
                var data = this.data.find(x => x.type == 'shipping');
                deleteBread('Promotion', data.id, {model_name:'Shop/Promotion'}).then(response => {
                    this.getData();
                    this.$store.commit('app/ADD_MESSAGE', {text: 'Succesfully deleted', type: 'success'});
                    this.shipping_free = false;
                })
            })
        },
        save(){
            if(this.$refs.discount_form.my_validate()){
                if(this.edit.id){
                    var func = editBread('Promotion', {model_name:'Shop/Promotion', ...this.edit}, this.edit.id);
                }else{
                    var func = storeBread('Promotion', {model_name:'Shop/Promotion', ...this.edit});
                }
                func.then(response => {
                    this.getData();
                    this.edit = null;
                    this.$store.commit('app/ADD_MESSAGE', {text: 'Successfully', type: 'success'});
                })
            }
        },
        exportToCsv(){
            exportToCsv().then(res => {})
        },
        exportUsageToCsv(){
            exportUsageToCsv().then(res=>{

            })
        },
        deleteSelected() {
            let text = this.selectedDiscounts.length > 0 ? this.$t('Are you sure, you want delete these promotions?') : this.$t('Are you sure, you want delete this promotion?');
            this.$confirm(this.$t('Delete promotions'), text, {accept: {text: 'Yes', color:'red'}, cancel: {text: 'No'}}).then(res => {
                this.selectedDiscounts.forEach(item => {
                    var index = this.data.findIndex(x => x == item);
                    deleteBread('Promotion', item.id, {model_name:'Shop/Promotion'}).then(response => {
                    })
                    if(index != -1) this.data.splice(index, 1);
                })
                this.$store.commit('app/ADD_MESSAGE', {text: this.$t('Succesfully deleted'), type: 'success'});
                this.selectedDiscounts = [];
            })
        }
    }
}
</script>
